<qpoint-map 
    [center]="center"
    [zoom]="10"
    [setZoomLevelOnFitBounds]="true"
    [stopFitToBoundsOnManualInteraction]="true"
    [zoomPosition]="zoomPosition"
    [minZoom]="0"
    [minZoomToShowLabels]="12"
    [gestureHandling]="'greedy'">
    <qpoint-map-marker *ngFor="let markerOption of mapMarkerOptions" [options]="markerOption"></qpoint-map-marker>
    <qpoint-map-polygon *ngIf="siteArea" [polygon]="siteArea"></qpoint-map-polygon>
    <qpoint-map-polyline *ngIf="pavingPath" [polyline]="pavingPath"></qpoint-map-polyline>
</qpoint-map>